window['LABEL_STYLES'] = window['LABEL_STYLES'] = window['LABEL_STYLES'] || {
  "default": {
    "backgroundColor": "#e9e9e9",
    "padding": "5px 10px 5px 10px",
    "borderRadius": "50%",
    "fontSize": "13px",
    "letterSpacing": "1px",
    "fontWeight": "600",
    "$$hashKey": "object:38"
  },
  "primary": [{
    "min": 10,
    "max": 12,
    "css": {
      "backgroundColor": "#ea6811",
      "padding": "5px 10px 5px 10px",
      "borderRadius": "50%",
      "fontSize": "24px",
      "letterSpacing": "1px",
      "fontWeight": "600",
      "$$hashKey": "object:38"
    }
  }, {
    "min": 8,
    "max": 10,
    "css": {
      "backgroundColor": "#ea6811",
      "padding": "5px 10px 5px 10px",
      "borderRadius": "50%",
      "fontSize": "16px",
      "letterSpacing": "1px",
      "fontWeight": "600",
      "$$hashKey": "object:38"
    }
  }]
}


export let associationMap =  new Map<string, string>();
associationMap.set('default', 'Black large');
associationMap.set('primary', 'Black large');
associationMap.set('ebony', 'Black text');
associationMap.set('vanilla', 'White text');
associationMap.set('white background small', 'White small');
associationMap.set('white background large', 'White large');
associationMap.set('white background small - shadow', 'White small - shadow');
associationMap.set('white background large - shadow', 'White large - shadow');
associationMap.set('black background small', 'Black small');
associationMap.set('black background large', 'Black large');
